var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChat = function SvgIconChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16a2.675 2.675 0 0 1-2.667-2.667V6.667C1.333 5.2 2.533 4 4 4h10.667c1.466 0 2.666 1.2 2.666 2.667v6.666c0 1.467-1.2 2.667-2.666 2.667H12v4l-4-4H4Zm24 8c1.467 0 2.667-1.2 2.667-2.667v-6.666C30.667 13.2 29.467 12 28 12h-8v1.333c0 2.934-2.4 5.334-5.333 5.334v2.666c0 1.467 1.2 2.667 2.666 2.667H20v4l4-4h4Z",
    fill: "#fff"
  })));
};
export default SvgIconChat;